module.exports = __webpack_public_path__ + "static/change-in-ocr-6787da0cf8a4893c53753ea73c8b831d.png";